export * from './modal.service';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/modal/_services/index.ts